module.exports = __webpack_public_path__ + "media/images/fancybox_overlay-f0eb344850a4f2f3deadac5c2629201e.png";